export const generateFormSessionId = (): string => {
  const uuid = crypto.randomUUID();
  return `form-${uuid}`;
};

